import uuid from 'react-uuid';
import getCroppedImg from 'components/ImageContainer/utilities/getCroppedImg';
import { PixelCrop } from 'components/ImageContainer/utilities/types';

const useImageUpload = () => {
  const getCroppedImage = async (imageSrc: string, croppedAreaPixels: PixelCrop): Promise<File | null> =>
    getCroppedImg({
      fileName: uuid(),
      imageSrc,
      pixelCrop: croppedAreaPixels,
    });

  return { getCroppedImage };
};

export default useImageUpload;
